
export default function getFoocusableElements(parent) {
  if (!parent) return null;
  const focusableElements = parent.querySelectorAll('a, button, input:not(:disabled), textarea, select, details, [tabindex]:not([tabindex="-1"])');
  return focusableElements;
}
